// Reads the Rails CSRF token from the meta tag rendered in the document
// head. SSR-safe (returns "" when there's no document). Every same-origin
// fetch/form POST needs this in an "X-CSRF-Token" header.
export function csrfToken(): string {
  if (typeof document === "undefined") return ""
  return (
    document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content") ?? ""
  )
}
